import { Injectable } from '@angular/core';
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  IHttpErrorPayload,
  HttpRequestPayload,
  IHttpSuccessPayload,
} from '@core/models';
import { HttpProviderService } from '../../../core/services/http-provider/http-provider.service';
import { AccountDetails } from '../../models/account-number.model';

@Injectable({
  providedIn: 'root',
})
export class AccountNameService {
  ReferenceNo = '0111735738426286';

  constructor(private httpProvider: HttpProviderService) {}

  getAccountInfo(accNo: string): Observable<any> {
    const request: HttpRequestPayload = {
      resource: `/accountinfo`,
      queryParams: [
        {
          key: 'accountNumber',
          value: accNo,
        },
      ],
      method: 'GET',
    };

    return this.httpProvider.invokeApi(request).pipe(
      map((response: IHttpSuccessPayload<any>) => {
        return response.body;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      })
    );
  }

  setAccountDetails(res: AccountDetails) {}
}

/*
const accountInfo : AccountInfoPostResponse = {
  accountDetail : null,
  httpStatus : err.status,
  errorCode : err.errorCode,
  errorDescription : err.errorDescription,
  errorMessage : err.errorMessage,
  /** @TODO Need to discuss about the api error constant *
  validationError : {  "ACCINFOERR001" : true }
}
*/
